import {Component, Input} from '@angular/core';
import {INotification} from '../../models';
import {NotificationTypeEnum} from '../../models/notification-types.enum';
import {IStore} from '../../../../shared/shared-models/store/store';
import {_USER_DEFAULT, IUser} from '../../../user-access/models';

@Component({
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss'],
    standalone: false
})
export class NotificationComponent {

  selectedStore: IStore;
  user: IUser;
  #notification: INotification;

  get getNotification(): INotification {
    return this.#notification;
  }


  get getUserDetail(): string {

    let colleague = '';
    if (this.#notification.userId === this.user.id) {
      const id = this.user.id;
      const index = id.indexOf('@');
      let user = '';
      if (index > -1) {
        user = `${id.slice(0, index + 1)}...`;
      }
      colleague = this.user.userName || user;

    } else {
      const index = this.#notification?.userId.indexOf('@');
      let colleagueId = '';
      if (index > -1) {
        colleagueId = `${this.#notification?.userId.slice(0, index + 1)}...`;
      }
      colleague = colleagueId;
    }
    return colleague;
  }

  @Input() set setNotification(notify: INotification) {
    this.#notification = notify;
  }

  @Input() set setUser(user: IUser) {
    if (this.getNotification.notificationId === 'loading') {
      this.user = {..._USER_DEFAULT};
    } else {
      this.user = user;
    }
  }

  @Input() set setUserStores(stores: IStore[]) {
    if (stores?.length > 0) {
      const notify = this.getNotification;
      if (notify?.storeId) {
        this.selectedStore = stores.find((store: IStore) => store.storeId === notify.storeId);
      }
    }
  }

}
